import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=ca78cbae&scoped=true&"
import script from "./answers.vue?vue&type=script&lang=js&"
export * from "./answers.vue?vue&type=script&lang=js&"
import style0 from "./answers.vue?vue&type=style&index=0&id=ca78cbae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca78cbae",
  null
  
)

export default component.exports